import { gql } from '@apollo/client';

export const GET_CREATIVE_TYPES = gql`
  query GET_CREATIVE_TYPES {
    getCreativeTypesV5
  }
`;
